export const SHIFT_OPTIONS = ['All', 'AM', 'PM'] as const
export const SEARCH_BY_OPTIONS = [
  { label: 'Driver Name', value: 'driver_name' },
  { label: 'Order Number', value: 'order_number' },
]
